import qs from "qs";
import axios from "@/axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  let options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/oauth-clients`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/oauth-clients/${id}?include=`, options)
    .then((response) => {
      let client = jsona.deserialize(response.data);
      delete client.links;
      return client;
    });
}

function add(client) {
  const payload = jsona.serialize({
    stuff: client,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/oauth-clients?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(client) {
  const payload = jsona.serialize({
    stuff: client,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/oauth-clients/${client.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/oauth-clients/${id}`, options);
}

function attachUsers(client) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/oauth-clients/attach-users/${client.id}?include=`,
      client,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function detachUsers(client) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/oauth-clients/detach-users/${client.id}?include=`,
      client,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}
export default {
  list,
  get,
  add,
  update,
  destroy,
  attachUsers,
  detachUsers,
};
